export default __webpack_public_path__ + "static/media/landing-page-head-img-4.273c9447.webp";